import { theme } from '@noths/polaris-client-ribbons-base';
import { shadowUp } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const drawerRoot = css`
  display: flex;
  flex-direction: column;
  background-color: var(--neutral-white-base);
`;

export const drawerHeader = css`
  flex-grow: 0;
`;

export const drawerBody = css`
  flex-grow: 1;
  overflow-y: auto;
`;

export const drawerFooter = css`
  flex-grow: 0;
  padding: ${spacing.lg}px ${spacing.md}px;
  ${shadowUp};
`;

export const activeFacetsWrapper = css`
  padding-bottom: ${spacing.xl}px;
  background-color: var(--brand-purple-5);
`;
